// For more information: https://github.com/orchidjs/tom-select

import TomSelect from 'tom-select';
import {each, includes} from 'lodash';

const loaded = [];

const initSelector = () => {
    each(document.querySelectorAll('select[data-selector]'), (element) => {
        // Prevent multiple executions
        if (includes(loaded, element)) {
            return;
        }
        loaded.push(element);
        const multipleMode = element.getAttribute('multiple');
        const instance = new TomSelect(element, {
            allowEmptyOption: ! multipleMode,
            onChange: () => {
                if (! multipleMode) {
                    instance.blur();
                }
            }
        });
    });
};

export default class TomSelectSelector {

    static init() {
        initSelector();
        document.addEventListener('livewire:load', () => {
            window.livewire.hook('message.processed', () => {
                initSelector();
            });
        });
    }

}
